import { Injectable } from '@angular/core';
import { HttpClient, HttpHandler, HttpRequest } from '@angular/common/http';
import { CacheService } from '../services/cache.service';

@Injectable({
  providedIn: 'root',
})
export class AuthInterceptor {
  constructor(
    private http: HttpClient,
    private _cacheService: CacheService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    // Get the auth token from the service.
    const authToken = this._cacheService.getItem('token') || '';

    const authorization = 'Bearer ' + authToken;

    // Clone the request and replace the original headers with
    // cloned headers, updated with the authorization.
    const authReq = req.clone({ setHeaders: { Authorization: authorization } });

    // send cloned request with header to the next handler.
    return next.handle(authReq);
  }
}
